<hd-dialog dialogTitle="contactUs.dialog.title" [closeRequested]="closeRequested">
  <ng-container dialogContent>
    <div class="flex flex-col gap-6">
      <div class="label-l text-neutral-30-secondary">{{ 'contactUs.dialog.text' | translate }}</div>
      <div class="flex justify-between">
        <div>{{ 'contactUs.dialog.email' | translate }}</div>
        <a [attr.href]="'mailTo:'+ contactEmail()">{{ contactEmail() }} <i class="icon-arrow-up-right text-neutral-30-secondary ml-2"></i></a>
      </div>

      <div class="flex justify-between">
        <div>{{ 'contactUs.dialog.whatsapp' | translate }}</div>
        <a [attr.aria-label]="'whatsapp.chatLink.ariaLabel' | translate" [attr.href]="whatsappLink()" target="_blank">
          {{ contactPhone() }} <i class="icon-arrow-up-right text-neutral-30-secondary ml-2"></i>
        </a>
      </div>
    </div>
  </ng-container>
</hd-dialog>
